export default function PickUpIcon(props) {
  return (
    <svg
      {...props}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 200.000000 200.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="#fff"
        stroke="none"
      >
        <path
          d="M630 1668 c-65 -44 -72 -135 -14 -189 37 -34 121 -34 158 0 78 74 39
        197 -66 208 -34 4 -50 0 -78 -19z"
        />
        <path
          d="M527 1438 c-17 -14 -187 -419 -187 -447 0 -9 57 -89 126 -178 l125
        -162 -60 -140 c-34 -76 -61 -151 -61 -165 0 -31 32 -66 59 -66 40 0 71 46 141
        207 38 89 70 169 70 178 0 24 -16 50 -79 129 -31 39 -79 99 -105 133 l-48 62
        43 105 c24 58 47 106 51 106 4 0 25 -37 47 -83 21 -46 47 -90 57 -98 13 -11
        47 -13 158 -11 158 4 176 11 176 67 0 51 -20 59 -149 65 l-115 5 -63 135 c-34
        74 -72 143 -84 153 -25 20 -78 22 -102 5z"
        />
        <path
          d="M1410 1383 c-102 -36 -186 -66 -187 -67 -2 -2 57 -187 61 -193 1 -1
        81 25 177 58 96 34 185 64 199 69 29 8 29 8 -7 118 -19 56 -32 82 -43 81 -8
        -1 -98 -30 -200 -66z"
        />
        <path
          d="M1029 1286 c-10 -21 0 -56 65 -238 87 -240 167 -448 172 -448 2 0 22
        7 44 16 34 14 38 19 30 35 -12 21 -118 307 -186 498 -24 68 -51 132 -60 142
        -24 26 -52 24 -65 -5z"
        />
        <path
          d="M1492 1145 c-118 -40 -215 -75 -217 -77 -4 -3 150 -462 159 -477 4
        -6 452 142 463 153 2 1 -30 99 -71 217 -41 118 -77 224 -81 237 -3 12 -14 22
        -23 21 -9 0 -113 -33 -230 -74z m275 -171 c34 -98 63 -184 63 -190 0 -12 -352
        -135 -362 -126 -8 8 -128 355 -128 371 0 5 24 17 53 27 28 9 57 19 63 21 6 2
        16 -15 23 -37 9 -31 16 -40 28 -36 8 3 26 9 40 12 17 5 22 11 18 23 -24 61
        -21 66 52 93 37 14 73 25 78 24 6 -2 38 -83 72 -182z"
        />
        <path
          d="M309 923 c-5 -15 -48 -127 -94 -248 -103 -271 -113 -305 -97 -339 14
        -32 57 -44 91 -25 27 15 60 92 162 376 l51 142 -51 62 -51 61 -11 -29z"
        />
        <path
          d="M1660 594 c-63 -23 -119 -45 -124 -47 -10 -3 14 -77 25 -77 19 0 266
        95 282 109 10 8 17 24 15 35 -5 36 -68 30 -198 -20z"
        />
        <path
          d="M1303 564 c-68 -34 -96 -130 -59 -202 52 -100 203 -95 257 8 25 46
        24 86 -4 134 -39 69 -123 95 -194 60z m123 -68 c37 -31 38 -84 4 -121 -64 -68
        -178 12 -135 95 28 55 85 66 131 26z"
        />
      </g>
    </svg>
  );
}
